"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _feedbackBenefitDialogContext = require("./feedbackBenefitDialogContext");
Object.keys(_feedbackBenefitDialogContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _feedbackBenefitDialogContext[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _feedbackBenefitDialogContext[key];
    }
  });
});
